module.exports = __webpack_public_path__ + "static/img/service_lark.14d8e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service_lark.png
// module id = GbVS
// module chunks = 2